export enum AppRoutes {
  HOME = "/",
  ABOUT = "/about",
  CONTACT = "/contact",
  PROJECT = "/project/:slug",
}
